export default {
    startday: '開始日',
    taxrate: '消費税',
    memo: 'メモ'
};
